import type { Brand } from '@awazevr/design-system.components.awaze-theme-provider'
import { isNovasolBrand } from '@awazevr/mfe-common.configs.brand'

interface PropertyCardDisplayRulesInput {
  brand: Brand
  datedSearch?: boolean
  fromPrice?: number | null
  price?: number | null
  siteSearch: boolean
}

/**
 * Display decisions shared by Property Card V2 and alternate presentations.
 * Keeping these rules outside either set of markup prevents experiments from
 * silently changing the meaning of the property data.
 */
export const getPropertyCardDisplayRules = ({
  brand,
  datedSearch,
  fromPrice,
  price,
  siteSearch,
}: PropertyCardDisplayRulesInput) => {
  const novasolBrand = isNovasolBrand(brand)

  return {
    displayedPrice: fromPrice || price || null,
    hasFromPrice: Boolean(fromPrice),
    showDepositTerms: siteSearch,
    showFromLabel: !novasolBrand,
    showPropertySpecs: !siteSearch,
    showPropertyType: !siteSearch,
    showStartDate: !fromPrice || novasolBrand,
    useDatedLayout: siteSearch ? false : Boolean(datedSearch),
  }
}
